import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-fulfillment',
  templateUrl: './order-fulfillment.component.html',
  styleUrls: ['./order-fulfillment.component.css']
})
export class OrderFulfillmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
